import http from './httpService';
// import { forumcategoriesUrl } from './../config/config.json';
// const forumcategoriesEndpoint = forumcategoriesUrl + '/actions';
const apiUrl = process.env.REACT_APP_API_URL;
const forumcategoriesEndpoint = apiUrl + '/forumcategories';


function actionUrl(id) {
  return `${forumcategoriesEndpoint}/${id}`;
}

function forumCatUrl(id) {
  return `${forumcategoriesEndpoint}/${id}`;
}

export function getActions() {
  return http.get(forumcategoriesEndpoint);
}

export function getAction(Id) {
  return http.get(actionUrl(Id));
}

export function saveAction(action) {
  const body = { ...action };

  if (action._id) {
    const id = action._id;
    delete body._id;
    delete body.id;

    return http.put(actionUrl(id), body);
  }
  // Add a new action (POST)
  return http.post(forumcategoriesEndpoint, body);
}


//delete actions
export function deleteAction(Id) {
  return http.delete(actionUrl(Id));
}

export function getForumCats() {
  return http.get(forumcategoriesEndpoint);
}

export function getForumCat(Id) {
  return http.get(forumCatUrl(Id));
}